import { supabase } from "./supabaseClient";

export async function getArCustomers(companyId) {
  const { data, error } = await supabase
    .from("v_ar_customer_balance_enriched")
    .select("*")
    .eq("company_id", companyId)
    .order("ar_balance", { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function getApVendors(companyId) {
  const { data, error } = await supabase
    .from("v_ap_vendor_balance_enriched")
    .select("*")
    .eq("company_id", companyId)
    .order("ap_balance", { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function getArOpenItems(companyId, customerId) {
  const { data, error } = await supabase
    .from("v_ar_open_items")
    .select("*")
    .eq("company_id", companyId)
    .eq("customer_id", customerId)
    .order("due_date", { ascending: true, nullsFirst: false });

  if (error) throw error;
  return data || [];
}

export async function getApOpenItems(companyId, vendorId) {
  const { data, error } = await supabase
    .from("v_ap_open_items")
    .select("*")
    .eq("company_id", companyId)
    .eq("vendor_id", vendorId)
    .order("due_date", { ascending: true, nullsFirst: false });

  if (error) throw error;
  return data || [];
}

export async function getReconciliation(companyId) {
  const [ar, ap] = await Promise.all([
    supabase
      .from("v_ar_reconciliation")
      .select("*")
      .eq("company_id", companyId)
      .order("posting_date", { ascending: false }),
    supabase
      .from("v_ap_reconciliation")
      .select("*")
      .eq("company_id", companyId)
      .order("posting_date", { ascending: false }),
  ]);

  if (ar.error) throw ar.error;
  if (ap.error) throw ap.error;

  return { ar: ar.data, ap: ap.data };
}

export async function createAllocationDraft(payload) {
  const { data, error } = await supabase
    .from("subledger_allocations")
    .insert(payload)
    .select("*")
    .single();

  if (error) throw error;
  return data;
}

export async function createApprovalRequest(payload) {
  const { data, error } = await supabase
    .from("subledger_approval_requests")
    .insert(payload)
    .select("*")
    .single();

  if (error) throw error;
  return data;
}

export async function listApprovals(companyId, status = "pending") {
  const { data, error } = await supabase
    .from("subledger_approval_requests")
    .select("*")
    .eq("company_id", companyId)
    .eq("status", status)
    .order("requested_at", { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function adminUpdateApproval(companyId, requestId, patch) {
  const { data, error } = await supabase
    .from("subledger_approval_requests")
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq("company_id", companyId)
    .eq("request_id", requestId)
    .select("*")
    .single();

  if (error) throw error;
  return data;
}
